import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/axios'
Vue.use(Vuex)

const userstore = new Vuex.Store({
    state: {
        user : [],
        updateUser : [],
        access_token : [],
        transfers: [],
        lineloginline: null
    },
    mutations: {
        // setPosts(state,posts) {
        //     state.posts = posts
        // },
        setTransfers(state, transfers) {
            state.transfers = transfers
        },
        getLoginLine(state, lineloginline) {
            state.lineloginline = lineloginline
        },
        getTokenLine(state, data) {
            state.access_token = data
        },
        getUser(state, data) {
            state.user = data
        },
        updateUser(state, data) {
            state.updateUser = data
        },
    },
    actions: {
        async loadTransfers(context) {
            let data = await axios.get("https://services.payremind.com/testapi/transfers.php").then((r) => {
                return r.data
            })
            context.commit("setTransfers", data)
        },
        async getLoginLine(context) {
            let data = await axios.get("https://services.payremind.com/api/v2/line/getlinklogin").then((r) => {
                return r.data
            })
            context.commit("getLoginLine", data)
        },
        async getTokenLine(context, options) {
            let data = await axios.get("https://services.payremind.com/api/v2/line/callback?code=" + options.code + "&state=" + options.state).then((r) => {
                return r.data
            })
            context.commit("getTokenLine", data)
        },
        async getUser(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/line/getUser",options,{headers : {'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'}}).then((r) => {
                return r.data
            })
            context.commit("getUser", data)
        },
        async updateUser(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/user/setting",options,{headers : {'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'}}).then((r) => {
                return r.data
            })
            context.commit("updateUser", data)
        },
        
        
        // async loadPosts(context,options){
        //     let data = await axios.get("http://10.94.98.239:3333/api/posts").then((r) => {
        //         return r.data
        //     })
        //     context.commit("setPosts",data)
        // },
        // async createPosts(context,options){
        //     let data = await axios.post("http://10.94.98.239:3333/api/posts",options).then(r => {
        //         r.data
        //     })
        //     await context.dispatch("loadPosts")
        // },
        // async deletePosts(context,options){
        //     let data = await axios.delete("http://10.94.98.239:3333/api/posts/"+options).then(r => {
        //         r.data
        //     })
        //     await context.dispatch("loadPosts")
        // },
    }
})

export default userstore

